import React, { useContext } from 'react';
import { store } from './reducer';
import { DataGrid } from '../../../../../../components/DataGrid/DataGrid';
import moment from 'moment-jalaali';
import { localText } from '../../../../../../langs/fa/data-grid';
import formatNumber from '../../../../../../fns/formatNumber';
import Avatar from '../../../../../../components/User/UserAvatar';

const List = () => {
  const {
    state: { progress, reports, page },
    dispatch,
    itemsCountPerPage,
  } = useContext(store);
  const columns = [
    {
      field: 'rowNumber',
      headerName: 'ردیف',
      width: 100,
    },
    {
      field: 'loadingDate',
      headerName: 'تاریخ',
      width: 100,
    },
    {
      field: 'destination',
      headerName: 'مقصد',
      width: 150,
    },
    {
      field: 'waybillType',
      headerName: 'نوع بارنامه',
      width: 150,
    },
    {
      field: 'tracingCode',
      headerName: 'کد رهگیری',
      width: 150,
    },
    {
      field: 'commissionDeposit',
      headerName: 'کارمزد متعلقه',
      flex: 1,
    },
    {
      field: 'transactionDate',
      headerName: 'تاریخ واریز',
      width: 150,
    },
  ];
  const _waybillType = {
    custom: 'سفارشی',
    police: 'پلیس راهی',
    software: 'کامل',
  };

  const handlePageChange = ({ page }) => {
    dispatch({ type: 'CHANGE_PAGE', payload: page });
  };

  var _reports = reports?.docs?.map
    ? reports.docs.map((report, i) => ({
        id: report._id,
        rowNumber: (page - 1) * itemsCountPerPage + (i + 1),
        loadingDate: report.log?.order
          ? moment(report.log.order.loadDate).format('jMM/jDD')
          : '',
        destination: report.log?.order?.destination?.title || '',
        waybillType: report.log?.order?.waybillType
          ? _waybillType[report?.log.order.waybillType]
          : '',
        tracingCode: report.log?.order?.tracingCode || '',
        commissionDeposit: report.log?.transaction?.amount
          ? formatNumber(report.log.transaction.amount)
          : '',
        transactionDate: report.log?.transaction
          ? moment(report.log.transaction.createdAt).format('jMM/jDD HH:mm')
          : '',
      }))
    : [];
  if (_reports?.length) {
    _reports.push({
      id: 'totals',
      rowNumber: '',
      loadingDate: '',
      destination: '',
      waybillType: '',
      commissions: reports?.commissionsTotal
        ? formatNumber(reports.commissionsTotal)
        : 0,
      tracingCode: '',
      commissionDeposit: reports?.commissionDepositTotal
        ? formatNumber(reports.commissionDepositTotal)
        : 0,
      transactionDate: '',
    });
  }
  return (
    <div style={{ height: 350 }}>
      <DataGrid
        rows={_reports}
        columns={columns}
        localeText={localText}
        pageSize={itemsCountPerPage}
        rowCount={reports?.totalDocs || 0}
        paginationMode="server"
        onPageChange={handlePageChange}
        loading={progress}
        disableMultipleSelection
        //   onCellClick={handleSelectOrder}
        density="compact"
      />
    </div>
  );
};

export default React.memo(List);
